import { Controller } from 'react-hook-form'

import { ScoreRadio } from '~/@mid_ui-form/score-radio/ScoreRadio'
import { ScoreRadioGroup } from '~/@mid_ui-form/score-radiu-group/ScoreRadioGroup'
import { useUser } from '~/@biz_account/useUser/useUser'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { useInvestorAnalysisStore } from '~/@pages_onboarding/investor-analysis/stage-analysis/useInvestorAnalysisStore'
import {
  assessExperienceSchema,
  type AssessExperienceSchema,
} from './assesExperience.schema'
import { useUnsophisticatedTestStore } from './useUnsophisticatedTestStore'
import type { AllStepsData } from './steps/AllStepsData'
import { useQuestionsV1 } from '../questions'

export function AssessExperienceStep() {
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()
  const { user } = useUser()
  const { testData, updateTestData, reset } = useUnsophisticatedTestStore(
    user?._id ?? null
  )
  const { setStage } = useInvestorAnalysisStore(user?._id ?? null)

  return (
    <FormStep
      defaultValues={
        testData ?? {
          investmentExperience:
            undefined as unknown as AssessExperienceSchema['investmentExperience'],
        }
      }
      schema={assessExperienceSchema}
      onStepCompleted={(updatedData) => {
        const investmentExperience = updatedData.investmentExperience?.value
        if (investmentExperience !== testData?.investmentExperience?.value) {
          reset()
        }

        updateTestData(updatedData as AllStepsData)

        const isInExperienced = investmentExperience === 'novice'
        setStage(isInExperienced ? 'inexperienced' : 'experienced')
      }}
      render={({ control }) => (
        <>
          <Controller
            control={control}
            name="investmentExperience"
            render={({ field }) => (
              <ScoreRadioGroup
                value={field.value}
                onValueChange={field.onChange}>
                {Object.entries(
                  unsophisticatedQuestions.investmentExperience.answers
                ).map(([value, answer]) => (
                  <ScoreRadio
                    key={value}
                    score={answer.score}
                    value={value}
                    label={answer.label}
                  />
                ))}
              </ScoreRadioGroup>
            )}
          />
        </>
      )}
    />
  )
}
